import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../slices/themeSlice";
import { DarkModeSwitch } from "react-toggle-dark-mode";

const ThemeToggle = () => {
    const currentTheme = useSelector((state) => state.theme.currentTheme);
    const dispatch = useDispatch();

    useEffect(() => {
        document.documentElement.dataset.theme = currentTheme;
    }, [currentTheme]);

    const handleThemeToggle = () => {
        dispatch(toggleTheme());
    };

    return (
        <DarkModeSwitch
            style={{ marginBottom: "2rem" }}
            checked={currentTheme === 'light'}
            onChange={handleThemeToggle}
            size='100%'
            moonColor="var(--color)"
            sunColor="var(--color)"
        />
    );
};

export default ThemeToggle;
